import { SiExpress, SiMongodb, SiRedux} from 'react-icons/si';
import {RiReactjsLine} from 'react-icons/ri';
import {FaNode} from 'react-icons/fa';
import { IoLogoJavascript } from 'react-icons/io';
import { TbSql } from 'react-icons/tb';

const data = [
    {id: 1, icon: <RiReactjsLine/>, title: 'React.js'},
    {id: 2, icon: <IoLogoJavascript/>, title: 'Javascript'},
    {id: 3, icon: <SiRedux/>, title: 'Redux'},
    {id: 4, icon: <FaNode/>, title: 'Node.js'},
    {id: 5, icon: <SiExpress/>, title: 'Express.js'},
    {id: 6, icon: <TbSql/>, title: 'SQL'},
    {id: 8, icon: <SiMongodb/>, title: 'MongoDB'},
]

export default data;